import { Route, Routes, useNavigate } from 'react-router-dom';
import { ROUTERS_PATH } from './consts';
import { Selections, Selection } from 'pages';
import { useEffect } from 'react';

export const Routers = ({
  updatelocation,
  externalRouteSelectionId,
}: {
  updatelocation?: Nullable<string>;
  externalRouteSelectionId?: Nullable<string>;
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (externalRouteSelectionId) navigate(externalRouteSelectionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalRouteSelectionId]);

  useEffect(() => {
    if (updatelocation) navigate('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatelocation]);

  return (
    <Routes>
      <Route path={ROUTERS_PATH.SELECTIONS} element={<Selections />} />
      <Route path={ROUTERS_PATH.NEW_SELECTION} element={<Selection />} />
      <Route path={ROUTERS_PATH.SELECTIONS}>
        <Route path="" element={<Selections />} />
        <Route path="/:selectionId" element={<Selection />} />
        <Route path="/copy/:copyId" element={<Selection />} />
      </Route>
    </Routes>
  );
};
